import { navigationPathsMap } from "../utils/navigationConstants";

export const navigationActions = {
    changeNavigation,
}



function changeNavigation(pathname, dispatch, intl) {
    const newNavState = navigationPathsMap.get(pathname);

    dispatch({
        type: "CHANGE_ROUTE",
        ...newNavState,
    });
}



